// extracted by mini-css-extract-plugin
export default {"root":"OptionCard_root__aneCo","selected":"OptionCard_selected__LWLyF","title":"OptionCard_title__NZWKW","subtitle":"OptionCard_subtitle__Z06sz"};